import React from 'react';

import './ObvTileSettings.scss';
import WidgetSettingsShowDataForEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsShowDataForEditor';
import WidgetSettingsBucketSizeEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsBucketSizeEditor';
import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';
import { ObvTileConfigState } from 'widgets/obvTile/store/config/ObvTileConfigState';

import { useObvTileConfigSlice } from 'widgets/obvTile/store/config/configslice';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const ObvTileSettingsText = `Obv Capsule Settings`;

export interface ObvTileSettingsProps {
    config?: ObvTileConfigState;
    onChange?: (nextDelta: Partial<ObvTileConfigState>) => void;
}

export default function ObvTileSettings(props: ObvTileSettingsProps) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useObvTileConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );

    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="ObvTileSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsShowDataForEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsBucketSizeEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
